var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 16.8V1.2H14.8V6.2336C14.2256 6.08121 13.6223 6 13 6C9.13401 6 6 9.13401 6 13C6 14.4009 6.41151 15.7056 7.12023 16.8H1.2ZM16 1V6.67363C18.3649 7.79709 20 10.2076 20 13C20 16.866 16.866 20 13 20C11.0927 20 9.36355 19.2372 8.10102 18H1C0.447715 18 0 17.5523 0 17V1C0 0.447716 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1ZM18.8 13C18.8 16.2033 16.2033 18.8 13 18.8C9.79675 18.8 7.2 16.2033 7.2 13C7.2 9.79675 9.79675 7.2 13 7.2C16.2033 7.2 18.8 9.79675 18.8 13ZM9.57617 15.5757L12.1519 13L9.57617 10.4243L10.4247 9.57579L13.0004 12.1515L15.5762 9.57568L16.4247 10.4242L13.8489 13L16.4247 15.5758L15.5762 16.4243L13.0004 13.8485L10.4247 16.4242L9.57617 15.5757ZM3 3H6V4.2H3V3ZM3 6H9.12399C8.52863 6.33036 7.97985 6.73448 7.48999 7.2H3V6ZM5.50369 10.2C5.65975 9.78234 5.84973 9.38123 6.07026 9H3V10.2H5.50369Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSubscription);
export default __webpack_public_path__ + "static/media/cancel-subscription.4438b2df1999a5c2ee066a86c72be5c5.svg";
export { ForwardRef as ReactComponent };